import React, { useMemo } from 'react'

import { useI18n } from '@affiliate-cabinet/i18n'
import { Badge, Skeleton } from '@affstore-ds/uikit'

import { getLevelTranslationKey } from '../../lib/utils/getLevelTranslationKey'
import { LevelBadgeViewPropertiesInterface } from './LevelBadgeView.types'

import { useLevelBadgeStyles } from './LevelBadgeView.styled'

export const LevelBadgeView = ({ 'data-testid': dataTestId, levelName, loading }: LevelBadgeViewPropertiesInterface) => {
  const translationKey = useMemo(() => getLevelTranslationKey(levelName), [levelName])

  const { classes } = useLevelBadgeStyles({ levelName })
  const { i18n } = useI18n()

  if (loading) {
    return <Skeleton data-testid={dataTestId} width={80} height={32} />
  }

  if (!translationKey) {
    return null
  }

  return (
    <Badge data-testid={dataTestId} classNames={{ label: classes.label, root: classes.root }} elementSize="s">
      {i18n.t(translationKey)}
    </Badge>
  )
}
